import type { SeedListData } from '@openx/types/segments.ts';

export const getInitialData = (data?: SeedListData[]) => {
  return {
    listData: data ?? [],
    baseListData: data ?? [],
  };
};
